<template>
  <v-carousel
    height="700"
    :show-arrows="false"
    cycle
    class="kiwi-register-slider mx-auto"
    hide-delimiter-background
    style="max-width: 600px;"
    v-if="slides"
  >
    <v-carousel-item v-for="(slide, i) in slides">
      <v-sheet
        color="transparent"
        height="100%"
      >
        <div class="d-flex flex-column flex-wrap justify-center align-center fill-height">
          <figure v-if="slide.logo !== false">
              <router-link to="/">
                <img :src="instituteStore.invertedLogo" height="54" :alt="instituteStore.name">
              </router-link>
          </figure>
          <img v-if="slide.image_place !== 'after_title'" :src="slide.image" class="kiwi-main-img mt-4" alt="">
          <article class="kiwi-text-white text-center">
            <div class="kiwi-fs-28 font-weight-bold">
              {{slide.title}}
            </div>
            <p class="kiwi-fs-15 mt-2">{{ slide.description }}</p>
          </article>
          <img v-if="slide.image_place === 'after_title'" :src="slide.image" class="kiwi-main-img mt-4" alt="" style="height: auto !important;">
        </div>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script setup>
import { computed } from 'vue';
import { useInstituteStore } from '@/stores/institute/institute-store';
import { ref } from 'vue';
const instituteStore = useInstituteStore()
const fallbackSlides = ref([
  {
    image: "/assets/Group 427320703.svg",
    description: "Join thousands of satisfied users who have elevated their performance with our comprehensive platform",
    title: "Grab an opportunity of learning from Industry experts"
  },
  {
    image: "/assets/Slide-Icon.svg",
    title: "Unlock your full potential with KiwiRead today!",
    description: "Begin by creating your account to access all the features and resources our website offers."
  },
  {
    image: "/assets/Layers.svg",
    image_place: 'after_title',
    title: "Nepal’s 1st trusted platform for mastering all exams",
    description: ""
  }
])
const slides = computed(() => {
  const iImages = instituteStore.configData?.institute?.images;
  return iImages && iImages.length  ? iImages : fallbackSlides.value
})
</script>